function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Descriptions, Divider, notification, List, Space, Modal } from "antd";
import { Table } from "react-bootstrap";
import { PersonVcard, MegaphoneFill, EnvelopeCheckFill, PersonCheckFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import SendSmsToList from "../components/forms/SendSmsToList";
import InSession from "../components/InSession";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Instructor = function Instructor() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataChanged = _useState2[0],
    setIsDataChanged = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comingSessions = _useState4[0],
    setComingSessions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSession = _useState8[0],
    setSelectedSession = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showSendSmsList = _useState0[0],
    setShowSendSmsList = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    inSessionVisible = _useState10[0],
    setInSessionVisible = _useState10[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getinstructorsessions/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setComingSessions(response.data.sessions);
      } else {
        notification.error({
          message: "Echec!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Echec!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              borderRadius: "0px 10px 0px 10px",
              background: "#FFDE59",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: "center"
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PersonVcard, {
                  size: 160
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 7,
          children: /*#__PURE__*/_jsxs(Descriptions, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Infos consultant"
            }),
            column: 2,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Prenom"
              }),
              children: Common.currentUser.prenom
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Nom"
              }),
              children: Common.currentUser.nom
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Mobile"
              }),
              children: Common.currentUser.mobile
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        children: /*#__PURE__*/_jsx(List, {
          itemLayout: "horizontal",
          dataSource: comingSessions,
          renderItem: function renderItem(item) {
            return /*#__PURE__*/_jsxs(List.Item, {
              actions: [/*#__PURE__*/_jsx("a", {
                onClick: function onClick() {
                  setSelectedSession(item);
                  setShowSendSmsList(true);
                },
                children: /*#__PURE__*/_jsx(MegaphoneFill, {
                  size: 24
                })
              })],
              children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                title: /*#__PURE__*/_jsx("b", {
                  children: item.label
                }),
                description: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Debut "
                    }), /*#__PURE__*/_jsx(Moment, {
                      date: item.start_date,
                      format: "DD/MM/YYYYY"
                    })]
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Debut "
                    }), /*#__PURE__*/_jsx(Moment, {
                      date: item.end_date,
                      format: "DD/MM/YYYYY"
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("div", {})]
            });
          }
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {}), selectedSession != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(EnvelopeCheckFill, {
            size: 24
          }), " COMMUNIQUER AUX PATICIPANTS"]
        }),
        width: "400px",
        open: showSendSmsList,
        onCancel: function onCancel() {
          setShowSendSmsList(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(SendSmsToList, {
          session: selectedSession,
          handler: function handler() {
            setIsDataChanged(true);
            setShowSendSmsList(false);
            notification.success({
              message: "Ok!",
              description: "L'envoie à été lancé avec succès"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(PersonCheckFill, {
            size: 24
          }), " PARTICIPANTS"]
        }),
        width: "900px",
        open: inSessionVisible,
        onCancel: function onCancel() {
          setInSessionVisible(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(InSession, {
          session: selectedSession,
          handler: function handler() {
            setIsDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          }
        })
      })]
    })]
  });
};
export default Instructor;